import { JOIN_TEAM_PREAMBLE } from "../constants/routes";

export const createJoinTeamLink = teamInformation => {
  const teamName = teamInformation.name.replace(" ", "%20");
  return `${window.location.origin}${JOIN_TEAM_PREAMBLE}?teamId=${teamInformation.id}&teamName=${teamName}`;
};
